// extracted by mini-css-extract-plugin
module.exports = {"jds-Tooltip":"Tooltip_jds-Tooltip__zqKvk","jds-Tooltip__label":"Tooltip_jds-Tooltip__label__giUbd","jds-Tooltip__childrenWrapper":"Tooltip_jds-Tooltip__childrenWrapper__oezD2"};